export default "__VITE_ASSET__c5rcsUzv__"